var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "auth-saas auth-saas--pro", attrs: { id: "wrapper" } },
    [
      _c("div", { staticClass: "auth-saas__layout auth-saas__layout--split" }, [
        _c(
          "aside",
          {
            staticClass:
              "auth-saas__brand-panel nk-split-stretch toggle-break-lg toggle-slide toggle-slide-right d-none d-lg-flex",
            attrs: {
              "data-toggle-body": "true",
              "data-content": "athPromo",
              "data-toggle-screen": "lg",
              "data-toggle-overlay": "true",
            },
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "auth-saas__brand-content" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("h2", { staticClass: "auth-saas__brand-headline" }, [
                _vm._v(
                  "Reset links expire quickly. Your session stays protected."
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "auth-saas__brand-copy" }, [
                _vm._v(
                  "\n                    We never reveal whether an email is registered. Check your inbox and spam folder for the next steps.\n                "
                ),
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "auth-saas__capability-list" }, [
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "auth-saas__capability-icon",
                      attrs: { "aria-hidden": "true" },
                    },
                    [_c("admin-icon", { attrs: { name: "lock" } })],
                    1
                  ),
                  _vm._v(" "),
                  _vm._m(2),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "auth-saas__capability-icon",
                      attrs: { "aria-hidden": "true" },
                    },
                    [_c("admin-icon", { attrs: { name: "shield" } })],
                    1
                  ),
                  _vm._v(" "),
                  _vm._m(3),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "auth-saas__capability-icon",
                      attrs: { "aria-hidden": "true" },
                    },
                    [_c("admin-icon", { attrs: { name: "headset" } })],
                    1
                  ),
                  _vm._v(" "),
                  _vm._m(4),
                ]),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "auth-saas__form-column auth-saas__form-column--split",
          },
          [
            _c("div", { staticClass: "absolute-top-right d-lg-none p-3" }, [
              _c(
                "a",
                {
                  staticClass: "auth-saas__icon-btn toggle",
                  attrs: {
                    href: "#",
                    "data-target": "athPromo",
                    "aria-label": "About password reset",
                  },
                },
                [_c("admin-icon", { attrs: { name: "info" } })],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "auth-saas__form-main" }, [
              _c(
                "div",
                {
                  staticClass:
                    "auth-saas__form-inner auth-saas__form-inner--enter",
                },
                [
                  _vm._m(5),
                  _vm._v(" "),
                  _c("div", { staticClass: "auth-saas__card" }, [
                    _c("p", { staticClass: "auth-saas__eyebrow" }, [
                      _vm._v("Account recovery"),
                    ]),
                    _vm._v(" "),
                    _c("h1", { staticClass: "auth-saas__title" }, [
                      _vm._v(_vm._s(_vm.trans("passwords.reset_password"))),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "auth-saas__subtitle" }, [
                      _vm._v(
                        "Enter the email associated with your admin account. We will send reset instructions if the address exists."
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "form",
                      {
                        staticClass: "form-validate is-alter",
                        attrs: { id: "passwordform" },
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.submit.apply(null, arguments)
                          },
                          keydown: function ($event) {
                            return _vm.passwordForm.errors.clear(
                              $event.target.name
                            )
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "label",
                              {
                                staticClass: "auth-saas__label",
                                attrs: { for: "pw-email" },
                              },
                              [_vm._v("Email")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "auth-saas__input-wrap" },
                              [
                                _c("admin-icon", {
                                  attrs: {
                                    name: "mail",
                                    "aria-hidden": "true",
                                  },
                                }),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.passwordForm.email,
                                      expression: "passwordForm.email",
                                    },
                                  ],
                                  staticClass: "auth-saas__input",
                                  attrs: {
                                    id: "pw-email",
                                    type: "text",
                                    name: "email",
                                    autocomplete: "email",
                                    placeholder: _vm.trans("auth.email"),
                                  },
                                  domProps: { value: _vm.passwordForm.email },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.passwordForm,
                                        "email",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("show-error", {
                              staticClass: "text-danger",
                              attrs: {
                                "form-name": _vm.passwordForm,
                                "prop-name": "email",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group mb-0" }, [
                          _c(
                            "button",
                            {
                              staticClass: "auth-saas__btn",
                              attrs: {
                                type: "submit",
                                disabled: _vm.passwordForm.busy,
                              },
                            },
                            [
                              _vm.passwordForm.busy
                                ? _c("span", {
                                    staticClass: "auth-saas__btn-spinner",
                                    attrs: { "aria-hidden": "true" },
                                  })
                                : _c("admin-icon", {
                                    attrs: {
                                      name: "send",
                                      "aria-hidden": "true",
                                    },
                                  }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.trans("passwords.reset_password"))
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "auth-saas__note" },
                      [
                        _c("router-link", { attrs: { to: "/login" } }, [
                          _vm._v("← Back to sign in"),
                        ]),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "auth-saas__brand-atmosphere",
        attrs: { "aria-hidden": "true" },
      },
      [
        _c("span", { staticClass: "auth-saas__brand-grid" }),
        _vm._v(" "),
        _c("span", {
          staticClass: "auth-saas__brand-glow auth-saas__brand-glow--a",
        }),
        _vm._v(" "),
        _c("span", {
          staticClass: "auth-saas__brand-glow auth-saas__brand-glow--b",
        }),
        _vm._v(" "),
        _c("span", { staticClass: "auth-saas__brand-beam" }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "auth-saas__brand-lockup" }, [
      _c(
        "span",
        {
          staticClass: "auth-saas__brand-mark",
          attrs: { "aria-hidden": "true" },
        },
        [_vm._v("S")]
      ),
      _vm._v(" "),
      _c("div", [
        _c("p", { staticClass: "auth-saas__brand-wordmark" }, [
          _vm._v("Sipinor"),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "auth-saas__brand-product" }, [
          _vm._v("Account recovery"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("strong", [_vm._v("Use a unique password")]),
      _vm._v(" "),
      _c("span", [
        _vm._v("Keep admin credentials separate from other accounts"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("strong", [_vm._v("Enable two-factor auth")]),
      _vm._v(" "),
      _c("span", [_vm._v("Add a second layer after you regain access")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("strong", [_vm._v("Ask an administrator")]),
      _vm._v(" "),
      _c("span", [_vm._v("Contact support if a reset link has expired")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "auth-saas__mobile-brand d-lg-none" }, [
      _c(
        "span",
        {
          staticClass: "auth-saas__brand-mark auth-saas__brand-mark--sm",
          attrs: { "aria-hidden": "true" },
        },
        [_vm._v("S")]
      ),
      _vm._v(" "),
      _c("span", [_vm._v("Sipinor Admin")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }